import Vue from "vue";

import UploadImage from "./components/share/upload-image/index.vue";
import ImageLoading from "./components/share/image-loading/index.vue";
import ImageDetail from "./components/share/image-detail/index.vue";
import CKEditor from "./components/share/ck-editor/index.vue";
import Radio from "./components/share/radio/radio.vue";
import CCheckbox from "./components/share/checkbox/CCheckbox.vue";

Vue.component("UploadImage", UploadImage);
Vue.component("ImageLoading", ImageLoading);
Vue.component("ImageDetail", ImageDetail);
Vue.component("CKEditor", CKEditor);
Vue.component("radio", Radio);
Vue.component("checkbox", CCheckbox);
